/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  Array<defs.appCenter.BizSecondaryAdminConfigResponseDto>
>;
export function request(
  params: API.appCenter.bizSecondaryAdminConfig.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizSecondaryAdminConfig/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
